import { render } from "./CohortTrendChart.vue?vue&type=template&id=fb884892&scoped=true"
import script from "./CohortTrendChart.vue?vue&type=script&lang=js"
export * from "./CohortTrendChart.vue?vue&type=script&lang=js"

import "./CohortTrendChart.vue?vue&type=style&index=0&id=fb884892&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb884892"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
